/**
 * Language selector flags (🇫🇮 🇬🇧) – no snippet edits.
 * Injects flags into header language dropdown for Finnish/English.
 */
(function () {
  var FLAG_MAP = {
    fi: '🇫🇮',
    en: '🇬🇧'
  };

  function baseLang(iso) {
    return (iso || '').split('-')[0].toLowerCase();
  }

  function getFlag(iso) {
    return FLAG_MAP[baseLang(iso)] || '';
  }

  function enhanceLanguageForms() {
    var forms = document.querySelectorAll('.js-localization-form');
    if (!forms.length) return;

    forms.forEach(function (form) {
      var input = form.querySelector('input[name="language_code"]');
      var currentIso = input ? input.value : '';
      var currentFlag = getFlag(currentIso);

      // Button flag
      var btn = form.querySelector('.localization-form__button');
      if (btn && currentFlag && !btn.querySelector('.localization-form__flag')) {
        var span = document.createElement('span');
        span.className = 'localization-form__flag';
        span.textContent = currentFlag;
        span.setAttribute('aria-hidden', 'true');
        btn.insertBefore(span, btn.firstChild);
      }

      // List flags
      var links = form.querySelectorAll('.localization-form__link[data-value]');
      links.forEach(function (link) {
        var iso = link.getAttribute('data-value');
        var flag = getFlag(iso);
        if (!flag) return;

        var text = link.querySelector('.localization-form__item-text');
        if (!text || text.querySelector('.localization-form__flag')) return;

        var f = document.createElement('span');
        f.className = 'localization-form__flag';
        f.textContent = flag;
        f.setAttribute('aria-hidden', 'true');
        text.insertBefore(f, text.firstChild);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceLanguageForms);
  } else {
    enhanceLanguageForms();
  }
})();

